import { Grid, Typography, useMediaQuery } from '@mui/material';
import { Field, FieldProps } from 'formik';
import React from 'react';
import ReactQuill from 'react-quill';
import { StyledErrorMessage } from '../StyledErrorMessage';
import { theme, useLanguage } from '../../common/GeneralUtils';
import { useAuth } from '../../session/InternalAuthProvider';
import { AccountData } from '../../api';
import 'react-quill/dist/quill.snow.css';

export const FormRichTextField = ({
  labelFieldName,
  label,
  disabled,
}: {
  labelFieldName: string;
  label: string;
  disabled: boolean;
}) => {
  const { authState } = useAuth();
  const account = authState.account as unknown as AccountData;
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const languages = account.customer_facing_widgets_languages;
  const language = useLanguage();
  const enLabel = language === 'en' ? `English ${label}` : `${label} באנגלית`;
  const heLabel = language === 'en' ? `Hebrew ${label}` : `${label} בעברית`;

  const modules = {
    toolbar: [[{ header: [1, 2, false] }], ['bold', 'italic', 'underline', 'strike', 'blockquote'], ['link']],
  };

  // Style for links in ReactQuill
  const styleId = 'dynamic-quill-link-styles';
  let styleElement = document.getElementById(styleId);
  if (styleElement) {
    styleElement.innerHTML = `.ql-editor a { color: #4BBD00 !important; text-decoration: underline !important; }`;
  } else {
    styleElement = document.createElement('style');
    styleElement.id = styleId;
    styleElement.innerHTML = `.ql-editor a { color: #4BBD00 !important; text-decoration: underline !important; }`;
    document.head.appendChild(styleElement);
  }

  return (
    <Grid
      container
      gap={2}
      border={isSmallScreen ? '1px solid #bfbfbf' : undefined}
      borderRadius={isSmallScreen ? '4px' : undefined}
      p={isSmallScreen ? 1 : undefined}
      flexDirection={isSmallScreen ? 'column-reverse' : 'row'}
      justifyContent={'flex-start'}>
      {languages.map((x) => {
        return (
          <Grid item xs={!isSmallScreen ? 4 : 12} key={x}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              {x === 'en' ? enLabel : heLabel}
            </Typography>
            <Field name={`${labelFieldName}.${x}`}>
              {({ field, form }: FieldProps<string>) => (
                <ReactQuill
                  theme="snow"
                  value={field.value || ''}
                  onChange={(value) => form.setFieldValue(field.name, value)}
                  modules={modules}
                  readOnly={disabled}
                  style={{ direction: x === 'he' ? 'rtl' : 'ltr' }}
                />
              )}
            </Field>
            <StyledErrorMessage name={`${labelFieldName}.${x}`} />
          </Grid>
        );
      })}
    </Grid>
  );
};
